import {container} from "@/services/registerServiceProvider";
import {ISegmentationTargetService} from "@/modules/Segmentation/services/ISegmentationTargetService";
import {SegmentationTargetService} from "@/modules/Segmentation/services/implementations/SegmentationTargetService";
import {ISegmentationFormStoreService} from "@/modules/Segmentation/services/ISegmentationFormStoreService";
import {SegmentationFormStoreService} from "@/modules/Segmentation/services/implementations/SegmentationFormStoreService";
import {ILogService} from "@/modules/Segmentation/services/ILoggerService";
import {LogService} from "@/modules/Segmentation/services/implementations/LogService";
import {ISegmentationImageService} from "@/modules/Segmentation/services/ISegmentationImageService";
import {SegmentationImageService} from "@/modules/Segmentation/services/implementations/SegmentationImageService";
import {IAgentTreeService} from "@/modules/Segmentation/services/IAgentTreeService";
import {AgentTreeService} from "@/modules/Segmentation/services/implementations/AgentTreeService";
import {IAddressService} from "@/modules/Segmentation/services/IAddressService";
import {AddressService} from "@/modules/Segmentation/services/implementations/AddressService";
import {ISegmentationRightsService} from "@/modules/Segmentation/services/ISegmentationRightsService";
import {SegmentationRightsService} from "@/modules/Segmentation/services/implementations/SegmentationRightsService";

container
    .register<IAddressService>("IAddressService", AddressService)
    .register<IAgentTreeService>("IAgentTreeService", AgentTreeService)
    .register<ISegmentationImageService>("ISegmentationImageService", SegmentationImageService)
    .register<ISegmentationTargetService>("ISegmentationTargetService", SegmentationTargetService)
    .registerSingleton<ISegmentationFormStoreService>("ISegmentationFormStoreService", SegmentationFormStoreService)
    .register<ILogService>("ILogService", LogService)
    .register<ISegmentationRightsService>("ISegmentationRightsService", SegmentationRightsService);

export {container};
